import { useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/components/state/store";
import { AppointmentRequestSlots } from "@/components/appointmentRequest/appointmentRequestSlots";
import ManagerAssignmentPlanner from "@/components/appointmentRequest/assignmentPlanner/managerAssignmentPlanner";

export default function AppointmentRequestBooking({
  subdomain,
}: {
  subdomain?: string;
}) {
  const [query] = useSearchParams();
  const { appointmentrequestId } = useParams();
  const companyId = useSelector((state: RootState) => state.parent.subjectId);
  return subdomain === "manage" && query.get("booking") === "workers" ? (
    <ManagerAssignmentPlanner key={`${companyId}-${appointmentrequestId}`} />
  ) : (
    <AppointmentRequestSlots subdomain={subdomain} />
  );
}
